import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 22,
    type: CHECKLIST_ITEM_TYPE.LINKED_CHECKLIST,
    manifestKey: 'LINKED_CHECKLIST',

    try_it: {
        button_label: 'View Linked Checklist',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'LinkedChecklistCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { linked_template_instance_id: 'demo-instance-001' },
        },
    },
    pre_flight_diff: [
        'GET /leads/{lead_pk}/task-template-instances/ — fetches sub-checklist instances with progress_pct',
        'User selects linked template instance',
        'Checklist item: PENDING → YES',
        'TaskActivity row created with action CHECKLIST_ITEM_COMPLETED',
        'effective_family resolves to linked sub-template\'s primary cell family (#188)',
    ],
    has_step2_throttle: false,
    validation_laboratory: null,
};
